<template>
  <v-container fluid justify-start>
    <v-card class="mx-auto" elevation="2">
      <v-list class="pa-0">
        <v-toolbar dense flat dark :color="appColor_Medium">
          
          <app-back-button v-bind:color="appColor_Dark" />

          <v-toolbar-title class="font-weight-regular">
            Admin Dashboard
          </v-toolbar-title>

          <span class="ml-15 mt-1">API Build</span>

          <v-badge
            class="ml-2"
            offset-x="3"
            offset-y="12"
            :content="apiVersionNumber"
            :value="!isLoadingApiAssemblyVersion"
            :color="badgeColor"
            ></v-badge>

          <v-spacer />
          
          <v-toolbar-items>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" :color="appColor_Toolbar" dark class="elevation-0 mr-2">
                  <!-- <v-icon class="pr-1">bolt</v-icon> -->
                  Event Log
                  <v-icon class="pl-1">arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="gotoRoute('UserEvents')">
                  <v-list-item-icon><v-icon>account_box</v-icon></v-list-item-icon>
                  <v-list-item-title>User Events</v-list-item-title>
                </v-list-item>
              </v-list>
              
              <v-divider />

              <v-list>
                <v-list-item @click="gotoRoute('ResidentEvents')">
                  <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                  <v-list-item-title>Resident Events</v-list-item-title>
                </v-list-item>
              </v-list>

              <v-divider />
              
              <v-list>
                <v-list-item @click="gotoRoute('KioskEvents')">
                  <v-list-item-icon><v-icon>computer</v-icon></v-list-item-icon>
                  <v-list-item-title>Kiosk Events</v-list-item-title>
                </v-list-item>
              </v-list>

              <v-divider />
              
              <v-list>
                <v-list-item @click="gotoRoute('PlaylistEvents')">
                  <v-list-item-icon><v-icon>featured_play_list</v-icon></v-list-item-icon>
                  <v-list-item-title>Playlist Events</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <!-- ABBY menu -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" :color="appColor_Toolbar" dark class="elevation-0 mr-2">ABBY
                  <v-icon class="pl-1">arrow_drop_down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="gotoRoute('AbbyActivityManager')">
                  <v-list-item-icon><v-icon>games</v-icon></v-list-item-icon>
                  <v-list-item-title>Activities</v-list-item-title>
                </v-list-item>

                <v-divider />

                <v-list-item @click="gotoRoute('AbbyAmbientInvitationManager')">
                  <v-list-item-icon><v-icon>picture_in_picture</v-icon></v-list-item-icon>
                  <v-list-item-title>Ambient Inivitations</v-list-item-title>
                </v-list-item>

                <v-divider />

                <v-list-item @click="gotoRoute('AbbyExpressionManager')">
                  <v-list-item-icon><v-icon>language</v-icon></v-list-item-icon>
                  <v-list-item-title>Expressions</v-list-item-title>
                </v-list-item>

                <v-divider />
                
                <v-list-item @click="gotoRoute('AbbyUpdateZipManager')">
                  <v-list-item-icon><v-icon>folder_zip</v-icon></v-list-item-icon>
                  <v-list-item-title>Update Zips</v-list-item-title>
                </v-list-item>

                <v-divider />
                
                <v-list-item @click="gotoRoute('KioskKeyTagMapper')">
                  <v-list-item-icon><v-icon>join_full</v-icon></v-list-item-icon>
                  <v-list-item-title>Key/Tag Mappings</v-list-item-title>
                </v-list-item>
              </v-list>
              
            </v-menu>

            <!-- GENIE menu -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" :color="appColor_Toolbar" dark elevation="0">Genie
                  <v-icon class="pl-1">arrow_drop_down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="gotoRoute('ConfigManager')">
                  <v-list-item-icon><v-icon>build</v-icon></v-list-item-icon>
                  <v-list-item-title>Configuration</v-list-item-title>
                </v-list-item>

                <v-divider />

                <v-list-item @click="$refs.release.click()">
                  <v-list-item-icon><v-icon>cloud_upload</v-icon></v-list-item-icon>
                  <v-list-item-title>Release Update</v-list-item-title>
                  <input
                    v-show="false"
                    type="file"
                    ref="release"
                    accept=".zip"
                    @change="fileChanged()"
                  />
                </v-list-item>

                <v-divider />

                <v-list-item @click="gotoRoute('GenieManualManager')">
                  <v-list-item-icon><v-icon>info</v-icon></v-list-item-icon>
                  <v-list-item-title>Manuals</v-list-item-title>
                </v-list-item>

                <v-list-item @click="gotoRoute('GeniePromotionalMediaManager')">
                  <v-list-item-icon><v-icon>info</v-icon></v-list-item-icon>
                  <v-list-item-title>Promotional Media</v-list-item-title>
                </v-list-item>

                <v-divider />

                <v-list-item @click="gotoRoute('MessagePurges')">
                  <v-list-item-icon><v-icon>mail</v-icon></v-list-item-icon>
                  <v-list-item-title>Message Purges</v-list-item-title>
                </v-list-item>

              </v-list>
            </v-menu>

          </v-toolbar-items>
        </v-toolbar>

        <v-list-item-group>
          <v-list-item @click="gotoRoute('OrganizationManager')">
            <v-list-item-icon>
              <v-icon large>schema</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="pb-2">
              <v-badge
                offset-x="3"
                offset-y="12"
                :content="organizationCount"
                :value="!isLoadingOrganizationSummary"
                :color="badgeColor"
                >
                <span :class="adminMenuTextClass">Organizations</span>
              </v-badge>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="gotoRoute('DomainManager')">
            <v-list-item-icon>
              <v-icon large>domain</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="pb-2">
              <v-badge
                offset-x="3"
                offset-y="12"
                :content="domainCount"
                :value="!isLoadingDomainSummary"
                :color="badgeColor"
                >
                <span :class="adminMenuTextClass">Domains</span>
              </v-badge>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="gotoRoute('FacilityManager')">
            <v-list-item-icon>
              <v-icon large>location_city</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="pb-2">
              <v-badge
                offset-x="3"
                offset-y="12"
                :content="facilityCount"
                :value="!isLoadingFacilitySummary"
                :color="badgeColor"
                >
                <span :class="adminMenuTextClass">Facilities</span>
              </v-badge>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="gotoRoute('KioskManager')">
            <v-list-item-icon>
              <v-icon large>computer</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span :class="adminMenuTextClass">Kiosks</span>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="genieKioskCount"
                :value="!isLoadingKioskSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Genie</v-chip>
              </v-badge>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="abbyKioskCount"
                :value="!isLoadingKioskSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Abby</v-chip>
              </v-badge>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="gotoRoute('ResidentManager')">
            <v-list-item-icon>
              <v-icon large>perm_identity</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span :class="adminMenuTextClass">Residents</span>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="genieResidentCount"
                :value="!isLoadingResidentSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Genie</v-chip>
              </v-badge>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="abbyResidentCount"
                :value="!isLoadingResidentSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Abby</v-chip>
              </v-badge>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="gotoRoute('AdminUserManager')">
            <v-list-item-icon>
              <v-icon large>people</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span :class="adminMenuTextClass">Users</span>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="adminCount"
                :value="!isLoadingUserSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Admin</v-chip>
              </v-badge>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="`${virtualVisitorCount}`"
                :value="!isLoadingUserSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Virtual Visitor</v-chip>
              </v-badge>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="`${familyFacilitatorCount}`"
                :value="!isLoadingUserSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Family Facilitator</v-chip>
              </v-badge>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="`${kioskManagerCount}`"
                :value="!isLoadingUserSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Kiosk Manager</v-chip>
              </v-badge>
              <v-badge
                offset-x="12"
                offset-y="7"
                :content="`${domainManagerCount}`"
                :value="!isLoadingUserSummary"
                :color="badgeColor"
                >
                <v-chip outlined class="ml-4">Domain Manager</v-chip>
              </v-badge>
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
        <v-divider />
        <v-list-item>
          <v-list-item-action>
            <v-btn
              icon
              v-clipboard:copy="accessToken"
              v-clipboard:success="onCopy"
              class="mt-2"
              >
              <v-icon>content_copy</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-title>
            Copy Token
          </v-list-item-title>
          <!-- Copy To Clipboard Button -->
        </v-list-item>
        <v-divider />
        <v-list-item>
          <v-list-item-action>
            <v-btn
              icon
              v-clipboard:copy="accessToken"
              v-clipboard:success="onDownload"
              :loading="isDownloading"
              class="mt-2"
              >
              <v-icon>download</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-title>
            Download Inventory Workbook
          </v-list-item-title>
          <!-- Copy To Clipboard Button -->
        </v-list-item>
      </v-list>

      <!-- Clipboard Copy Snackbar-->
      <v-snackbar v-model="copySnackbar" :timeout="2000">
        Copied!
        <v-btn dark text @click="copySnackbar = false" :color="appColor_Medium"
        >Close</v-btn
        >
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import appService from '@/app.service.js'
import { AppColor } from '@/config.js'
import AppBackButton from '@/components/App/AppBackButton'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminDashboard',
  components: {
    AppBackButton
  },
  data() {
    return {
      // colors
      appColor_Medium: AppColor.Medium,
      appColor_Dark: AppColor.Dark,
      appColor_Toolbar: AppColor.Toolbar,
      appColor_Genie: AppColor.KioskTypeGenie,
      appColor_Abby: AppColor.KioskTypeAbby,

      // styles
      badgeColor: 'amber',
      adminMenuTextClass: 'text-h5 font-weight-light',

      // boolean
      isLoadingApiAssemblyVersion: true,
      isLoadingOrganizationSummary: true,
      isLoadingDomainSummary: true,
      isLoadingFacilitySummary: true,
      isLoadingKioskSummary: true,
      isLoadingResidentSummary: true,
      isLoadingUserSummary: true,
      isDownloading: false,

      apiVersion: 'unknown',

      // values
      apiVersionNumber: 0,
      domainCount: 0,
      organizationCount: 0,
      facilityCount: 0,
      genieKioskCount: 0,
      abbyKioskCount: 0,
      genieResidentCount: 0,
      abbyResidentCount: 0,
      adminCount: 0,
      domainManagerCount: 0,
      kioskManagerCount: 0,
      familyFacilitatorCount: 0,
      virtualVisitorCount: 0,

      copySnackbar: false,

      uploadZipFile: null
    }
  },
  computed: {
    ...mapGetters(['profile', 'accessToken']),
    isValidSession () {
      return !this.isNullOrUndefined(this.profile.id)
    }
  },
  methods: {
    loadData () {
      const self = this
      if (!this.isValidSession) return

      self.getApiVersion().then(data => {
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.apiVersionNumber = data

          self.getSummaryOrganization().then(data =>{
            if (data.errorSeverity > 0) {
              self.handleError(data)
            } 
            else {
              self.organizationCount = data.count

              self.getSummaryDomain().then(data => {
                if (data.errorSeverity > 0) {
                  self.handleError(data)
                } else {
                  self.domainCount = data.count

                  self.getSummaryFacility().then(data => {
                    if (data.errorSeverity > 0) {
                      self.handleError(data)
                    } else {
                      self.facilityCount = data.count

                      self.getSummaryKiosk().then(data => {
                        if (data.errorSeverity > 0) {
                          self.handleError(data)
                        } else {
                          self.genieKioskCount = data.genieCount
                          self.abbyKioskCount = data.abbyCount

                          self.getSummaryResident().then(data => {
                            if (data.errorSeverity > 0) {
                              self.handleError(data)
                            } else {
                              self.genieResidentCount = data.genieCount
                              self.abbyResidentCount = data.abbyCount

                              self.getSummaryUser().then(data => {
                                if (data.errorSeverity > 0) {
                                  self.handleError(data)
                                } else {
                                  self.adminCount = data.adminCount
                                  self.domainManagerCount = data.domainManagerCount
                                  self.kioskManagerCount = data.kioskManagerCount
                                  self.familyFacilitatorCount = data.familyFacilitatorCount
                                  self.virtualVisitorCount = data.virtualVisitorCount
                                }
                                self.isLoadingUserSummary = false
                              })
                            }
                            self.isLoadingResidentSummary = false
                          })
                        }
                        self.isLoadingKioskSummary = false
                      })
                    }
                    self.isLoadingFacilitySummary = false
                  })
                }
                self.isLoadingDomainSummary = false
              })
              self.isLoadingOrganizationSummary = false
            }
          })
        }
        self.isLoadingApiAssemblyVersion = false
      })

      self.getSummaryResident()
      self.getSummaryUser()
    },

    getApiVersion () {
      const self = this
      return new Promise(resolve => {
        appService.getAdminApiAssemblyVersion().then(data => {
          resolve(data)
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    getSummaryOrganization () {
      const self = this
      return new Promise(resolve => {
        appService.getAdminSummaryOrganization().then(data => {
          resolve(data)
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    getSummaryDomain () {
      const self = this
      return new Promise(resolve => {
        appService.getAdminSummaryDomain().then(data => {
          resolve(data)
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    getSummaryFacility () {
      const self = this
      return new Promise(resolve => {
        appService.getAdminSummaryFacility().then(data => {
          resolve(data)
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    getSummaryKiosk () {
      const self = this
      return new Promise(resolve => {
        appService.getAdminSummaryKiosk().then(data => {
          resolve(data)
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    getSummaryResident () {
      const self = this
      return new Promise(resolve => {
        appService.getAdminSummaryResident().then(data => {
          resolve(data)
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    getSummaryUser () {
      const self = this
      return new Promise(resolve => {
        appService.getAdminSummaryUser().then(data => {
          resolve(data)
        }).catch(e => { self.handleCriticalError(e) })
      })
    },

    resetFileInput () {
      this.$refs.release.type = 'hidden'
      this.$refs.release.type = 'file'
    },

    release () {
      const self = this

      self.$confirm.show({
        title: 'Release Update?',
        text: `Zip File: <b>${self.uploadZipFile.name}</b></br>`,
        formColor: 'green',
        width: '230',
        onConfirm: () => {
          self.uploadRelease()
        },
        onCancel: () => {
          self.resetFileInput()
        }
      })
    },

    uploadRelease () {
      const self = this

      let formData = new FormData()
      formData.append('file', self.uploadZipFile)

      self.$upload.execute({
        formData: formData,
        url: 'genieupdates/release',
        fileCount: 1,
        onComplete: (data) => {
          if (data.errorSeverity > 0) {
            self.handleError(data)
          } else {
            self.resetFileInput()
            self.$alert.show({
              title: 'Success',
              formColor: 'success',
              width: '280',
              text: `Update successfully released.</br>Next update level is <b>${data.nextUpdate}</b>.`
            })
          }
        }
      })
    },

    gotoRoute(name) {
      this.$store.dispatch('pushRoute', { name: name })
      this.$router.push({ name: name })
    },

    onCopy () {
      this.copySnackbar = true
    },
    
    // events

    onDownload () {
      const self = this
      const now = new Date().toISOString().split('T')[0]
      const fileName = 'AAT_' + now
      self.isDownloading = true

      appService.getWorkbook(fileName).then(() => {
        self.isDownloading = false
      }).catch(e => { self.handleCriticalError(e) })
    },

    fileChanged () {
      const file = this.$refs.release.files[0]
      const ext = file.name.split('.').pop()
      if (ext !== 'zip') {
        this.$error.show({
          title: 'Invalid Filename',
          text: `Filename not valid.<br/><br/>Expected a zip file.`,
          severity: 0
        })
      } else {
        this.uploadZipFile = file
        this.release()
      }
    },

    handleError (result) {
      this.$error.show({
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    isValidSession(val) {
      if (val === null) return
      this.loadData()
    }
  }
}
</script>
